import { render, staticRenderFns } from "./IdentityToolsSwitchableItem.vue?vue&type=template&id=058c166e&lang=pug&"
import script from "./IdentityToolsSwitchableItem.vue?vue&type=script&lang=js&"
export * from "./IdentityToolsSwitchableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports